export default __webpack_public_path__ + "static/media/premium.a9951f0f.png";